module.exports = __webpack_public_path__ + "static/media/Formular-Bold.164b6025.otf";